import fetchClient from '../utils/fetchClient';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { API_BASE_URL } from '../config';
import { httpClient } from './httpClient';

// === Main backend: S3 file upload ===

export const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await httpClient.request(`${API_BASE_URL}/uploads/upload`, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.detail || response.statusText);
    }
    return response.json();
};

// === AGR backend: catalog uploads (Мой канал) ===

export const fetchChannelProfile = async () => {
    return fetchClient.get('/catalog/uploads/profile');
};

export const updateChannelProfile = async ({ name, avatar_url, social_links }) => {
    return fetchClient.put('/catalog/uploads/profile', { name, avatar_url, social_links });
};

export const fetchCatalogUploadQuota = async () => {
    return fetchClient.get('/catalog/uploads/quota');
};

export const fetchCatalogUploads = async () => {
    return fetchClient.get('/catalog/uploads');
};

export const createCatalogUpload = async ({ cloud_url, upload_id, file_name, file_size, category_id, title, publish }) => {
    return fetchClient.post('/catalog/uploads', { cloud_url, upload_id, file_name, file_size, category_id, title, publish });
};

export const updateCatalogUpload = async (uploadId, { title, category_id, publish }) => {
    return fetchClient.put(`/catalog/uploads/${uploadId}`, { title, category_id, publish });
};

export const deleteCatalogUpload = async (uploadId) => {
    return fetchClient.delete(`/catalog/uploads/${uploadId}`);
};

export const createSlotsInvoice = async (packSize = 5) => {
    return fetchClient.post('/catalog/uploads/buy-slots', { pack_size: packSize });
};

// === React Query hooks ===

export function useChannelProfile() {
    return useQuery('channelProfile', fetchChannelProfile);
}

export function useUpdateChannelProfile() {
    const queryClient = useQueryClient();
    return useMutation(updateChannelProfile, {
        onSuccess: () => {
            queryClient.invalidateQueries('channelProfile');
        }
    });
}

export function useCatalogQuota() {
    return useQuery('catalogUploadQuota', fetchCatalogUploadQuota);
}

export function useCatalogUploads() {
    return useQuery('catalogUploads', fetchCatalogUploads);
}

export function useCreateCatalogUpload() {
    const queryClient = useQueryClient();
    return useMutation(createCatalogUpload, {
        onSuccess: () => {
            queryClient.invalidateQueries('catalogUploads');
            queryClient.invalidateQueries('catalogUploadQuota');
        }
    });
}

export function useDeleteCatalogUpload() {
    const queryClient = useQueryClient();
    return useMutation(deleteCatalogUpload, {
        onSuccess: () => {
            queryClient.invalidateQueries('catalogUploads');
            queryClient.invalidateQueries('catalogUploadQuota');
        }
    });
}

export function useUpdateCatalogUpload() {
    const queryClient = useQueryClient();
    return useMutation(
        ({ uploadId, data }) => updateCatalogUpload(uploadId, data),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('catalogUploads');
                queryClient.invalidateQueries('channelProfile');
            }
        }
    );
}

export function useUploadFile() {
    const queryClient = useQueryClient();
    return useMutation(uploadFileToS3, {
        onSuccess: () => {
            queryClient.invalidateQueries('catalogUploads');
        }
    });
}
